import { cloneDeep } from 'lodash';
import { useState } from 'react';
import { DashboardJson } from '../modules/models';

export const enum UNDO_REDO_EVENT_TYPE {
  Undo,
  Redo,
}

export const useUndoRedo = () => {
  const [undoStack, setUndoStack] = useState([] as DashboardJson[]);
  const [redoStack, setRedoStack] = useState([] as DashboardJson[]);

  const resetStack = () => {
    setUndoStack([] as DashboardJson[]);
    setRedoStack([] as DashboardJson[]);
  };

  const addAction = (json: DashboardJson): void => {
    setUndoStack([...undoStack, json]);
    setRedoStack([] as DashboardJson[]);
  };

  const undoAction = (json: DashboardJson): DashboardJson => {
    const item = undoStack.pop();
    setUndoStack(undoStack);
    setRedoStack([...redoStack, cloneDeep(json)]);
    return item || {};
  };

  const redoAction = (json: DashboardJson): DashboardJson => {
    const item = redoStack.pop();
    setRedoStack(redoStack);
    setUndoStack([...undoStack, cloneDeep(json)]);
    return item || {};
  };

  const canUndoAction = undoStack.length > 0;
  const canRedoAction = redoStack.length > 0;
  const isEmptyStack = undoStack.length == 0;

  return {
    canUndoAction,
    canRedoAction,
    isEmptyStack,
    addAction,
    undoAction,
    redoAction,
    resetStack,
  };
};
